import { Colors } from '@sigma-frontend-libs/commons'

import { components, eventHandlers, icons, isHEX, numberToPxOrString, placements } from '@/utils'

import render from './render'

export default {
  name: components.icon,

  mixins: [ eventHandlers ],

  props: {
    value: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },
    color: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    tooltip: String,

    link: Boolean,
    left: Boolean,
    right: Boolean,

    size: {
      type: Number,
      default: 24
    }
  },

  computed: {
    $_class() {
      const result = {
        [`${components.icon}`]: true,
        [`${components.icon}--link`]: this.link,
        [`${components.icon}--left`]: this.left,
        [`${components.icon}--right`]: this.right
      }
      if (this.color && !isHEX(this.color)) {
        result[`${components.icon}--${this.color}`] = true
      }

      const icon = this.value || Array.isArray(this.$slots.default) && this.$slots.default[0].text
      if (icon) {
        result[`${components.icon}__icon--${icon}`] = true
      }

      return result
    },

    $_style() {
      const result = { 'font-size': numberToPxOrString(this.size) }
      if (isHEX(this.color)) {
        result.color = this.color
      }

      return result
    },

    $_directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: {
            value: this.tooltip,
            placement: placements.top
          }
        })
      }

      return result
    }
  },

  render
}
